<template>
  <div
    v-if="showSplash"
    data-test-splash-circle
    :class="['splash-circle', bgColourClass, { 'splash-circle--loaded': setLoadedClass }]"
  >
    <div class="text-container">
      <h2 v-if="showTitle" :class="titleClass" data-test-splash-circle-title v-html="title" />
      <p
        v-if="showText"
        :class="[textClass, { 'hide-for-small-only': hideTextOnMobile }]"
        data-test-splash-circle-text
        v-html="text"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'SplashCircle',
  props: {
    bgColourClass: {
      type: String,
      default: () => 'site-secondary-color'
    },
    title: {
      type: String,
      default: () => ''
    },
    text: {
      type: String,
      default: () => ''
    },
    hideTextOnMobile: {
      type: Boolean,
      default: () => false
    },
    titleClass: {
      type: String,
      default: () => 'splash-circle__title'
    },
    textClass: {
      type: String,
      default: () => 'splash-circle__text'
    }
  },
  data() {
    return {
      setLoadedClass: false
    };
  },
  computed: {
    showTitle(): boolean {
      return this.title !== '';
    },
    showText(): boolean {
      return this.text !== '';
    },
    showSplash(): boolean {
      return this.title !== '' || this.text !== '';
    }
  },
  mounted() {
    this.loadedClassDelay();
  },
  methods: {
    loadedClassDelay() {
      setTimeout(() => {
        this.setLoadedClass = true;
      }, 50);
    }
  }
});
</script>

<style lang="scss" scoped>
@import 'src/styles/all';

.splash-circle {
  width: rem-calc(160);
  height: rem-calc(160);
  border-radius: 50%;
  color: $white;
  position: absolute;
  transform: scale(0);
  transition: all 0.2s ease-out;
  z-index: 4;
  display: flex;
  justify-content: center;

  &__title {
    font-size: rem-calc(25);
  }

  &__text {
    font-size: rem-calc(13);
  }

  &--loaded {
    transition-delay: 0.5s;
    transform: scale(1);
  }

  @include breakpoint(large up) {
    width: rem-calc(200);
    height: rem-calc(200);

    &__title {
      font-size: rem-calc(36);
    }

    &__text {
      font-size: rem-calc(15);
    }
  }

  div.text-container {
    margin: 0;
    text-align: center;
    padding: rem-calc(20);
    position: absolute;
    top: 50%;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);

    @include breakpoint(medium up) {
      padding: rem-calc(20);
    }

    @include breakpoint(small only) {
      padding: rem-calc(14);
    }

    h2 {
      line-height: 1;
      color: $white;
      margin-bottom: rem-calc(5);
    }

    p {
      margin-bottom: 0;
    }
  }

  &.site-primary-color {
    background-color: $primary-color;
  }

  &.site-secondary-color {
    background-color: $disturber-color;
  }
}
</style>
